<template>
  <!-- 
    @Author shirleywanghui@didichuxing.com
    @Date 2022-04-26
    @Description cgc推荐页改版 - 分享区域 - local常用分享方式
    @动态项
      1.背景颜色 2.按钮 3.文案
      先静态样式，再注入逻辑
    @分享注意事项
      埋点
      不同渠道 - bridge分享方法
      不同渠道 - icon对应关系
      不同地区 - 常用渠道
      同一渠道 - 分享链接 短链等细节recommendPage.share.url
      渠道分享 - 成功后toast提示

      {
        config: {
          common: {title,url,content,icon}, whatsapp: {}, facebook: {}, twitter: {}, sms: {}, email: {}, systemEntrance: {}
        },
        order: [ 'whatsapp', 'facebook', 'twitter']
      }

      1、br、co、cr、mx唤起whatsapp
      2、jp唤起line 两种情况下的按钮颜色和图标是不是要区分一下，让用户知道当前点击这个按钮时会通过啥渠道分享出去
  -->
    <div class="xtc-share-button-local-channel" @click.stop="plantformClick(plantform)">
      <img class="icon" :src="iconObj[plantform.name]" />
      <!-- <div class="text">{{`Compartir por $5`}}</div> -->
      <div class="text">{{$t('FoodC_CGC_Invite_immediately_dQRx' /** 立即邀请 */)}}</div>
    </div>
</template>
<script>
export const PLATFORM_BRIDGE_METHOD = {
  whatsapp: 'shareWhatsApp',
  line: 'shareLine',
  facebook: 'shareFacebook',
  messenger: 'shareFBMessenger',
  twitter: 'shareTwitter',
  telegram: 'shareTelegram'
}
export default {
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    // 数据返回当前用户--社交媒体枚举--取第一个local常用
    plantform () {
      /** 分享内容如下，比如：
        {
          "name": "whatsapp",
          "icon": "",
          "bridge": "shareWhatsApp",
          "config": {
              "title": "¡Hasta MX$130.00 OFF en tu primer pedido!",
              "url": "https://didi-food.onelink.me/ssCr/redeemCode?code=FOOD-J82RPF&activityType=1&locale=zh-CN",
              "content": "Hola, tu amigo te ha enviado MX$130.00 de descuento para tu primer pedido. Obténlo aquí:",
              "icon": "https://img0.didiglobal.com/static/soda_public/do1_bpfsH5TPLkgWk3faU3Zu"
          }
      } */
      const { config, order } = this.config
      const key = order[0]
      const channel = {
        name: key || '',
        // icon: PLATFORM_ICON_MAP[key] || '',
        bridge: PLATFORM_BRIDGE_METHOD[key] || '',
        config: config[key]
      }
      return channel
    }
  },
  data () {
    return {
      iconObj: {
        'whatsapp': 'https://img0.didiglobal.com/static/soda_public/do1_q3D2qFwjgtGwyWYyihMe',
        'line': 'https://img0.didiglobal.com/static/soda_public/do1_Lp6yLMI3Jkb1fjciuEqt'
      }
    }
  },
  methods: {
    async shareCommon (bridgMethod, config) {
      this.$emit('trackShareButtonClick', 1)
      let shareConfig = {...config}
      // 分享whatsapp、facebook、Mycenter、调面板都不支持回调, 不做回调处理
      await this.SodaBridge(bridgMethod, {
        url: shareConfig.url,
        title: shareConfig.title,
        content: shareConfig.content,
        icon: shareConfig.icon
      })
      // .then((res) => {
      //   if (res && res.errno === 0) {
      //     this.isShow = true
      //   }
      // })
    },
    plantformClick (plantform) {
      let config = plantform.config || this.config.config.common
      this.shareCommon(plantform.bridge, config)
    }
  }
}
</script>
<style scoped lang="stylus">
.xtc-share-button-local-channel {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 638px;
  height: 88px;
  background-image: linear-gradient(-89deg, #4CD25B 0%, #40D859 99%);
  border-radius: 12px;
  &.line {
    background-image: linear-gradient(-89deg, #00d200 0%, #00d200 99%);
  }
  .icon {
      width: 48px;
      height: 48px;
    }
    .text {
      margin-left: 16px;
      height: 43px;
      line-height: 43px;
      // font-family: DiDiSansPro-Medium;
      font-family: Aspira Medium;
      font-size: 36px;
      color: #FFFFFF;
      letter-spacing: 0;
      font-weight: 500;
    }
}
</style>